import { render, staticRenderFns } from "./Stopped.vue?vue&type=template&id=cf23b848&scoped=true&"
import script from "./Stopped.vue?vue&type=script&lang=js&"
export * from "./Stopped.vue?vue&type=script&lang=js&"
import style0 from "./Stopped.vue?vue&type=style&index=0&id=cf23b848&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf23b848",
  null
  
)

export default component.exports